<template>
  <v-flex xs12 row>
  	<v-layout row wrap>
  		<v-flex xs12>
  			
  		</v-flex>
  	</v-layout>

	<v-layout py-3>
   		<v-flex xs12 sm10 offset-sm1>
   			<v-card>
	   			<v-card-title>
            
            <v-text-field v-model="filter.id" label="Dispatch ID" class="mr-3"></v-text-field>

            <v-autocomplete v-model="filter.status" :items="statuses" item-text="title" item-value="id" label="Status" class="mr-3"></v-autocomplete>
            
            <v-autocomplete v-model="filter.warehouse_id" :items="warehouses" item-text="title" item-value="id" label="Warehouse" class="mr-3"></v-autocomplete>

            <search-btn @click="filterData" />

            <v-spacer></v-spacer>
              <v-btn v-if="hasCreateAccess" to="/stock-dispatch" round color="primary" dark small class="ml-4">Add New</v-btn>

			    </v-card-title>
	   			<v-data-table
				    :headers="headers"
				    :loading="processing"
				    :items="items"
				    item-key="id"
				    hide-actions
            disable-initial-sort
				  >
				  	<v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
				    <template slot="headerCell" slot-scope="props">
				      <v-tooltip bottom>
				        <span slot="activator">
				          {{ props.header.text }}
				        </span>
				        <span>
				          {{ props.header.text }}
				        </span>
				      </v-tooltip>
				    </template>
				    <template slot="items" slot-scope="props">
              <tr is="dispatch-list-item" :item="props.item" @confirm="confirmApproveItem" @cancel="confirmCancelItem"></tr>
				    </template>
				    <template slot="no-data" v-if="!processing && !items.length">
				      <v-alert :value="true" color="error" icon="warning">
				        Sorry, nothing to display here :(
				      </v-alert>
				    </template>
				  </v-data-table>

          <v-pagination @loadPage="loadPage" />

			</v-card>
   		</v-flex>

      <action-dialog action="approve" :status="approveDialog" @close="closeApproveDialog" @success="approveStockDispatch" />
      <action-dialog action="cancel" :status="cancelDialog" @close="closeCancelDialog" @success="cancelStockDispatch" />

   	</v-layout>
    
  </v-flex>
</template>

<script>

  import StockDispatchListItem from './StockDispatchListItem'

  export default {
    name: 'StockDispatchList',
    data () {
      return {
      	title: "Stock Dispatch List",
      	processing: false,
      	items: [],
        headers: [
          { text: 'ID', value: 'id'},
          { text: 'Dispatch Date', value: 'date'},
          { text: 'Factory', value: 'factory_name'},
          { text: 'Warehouse', value: 'warehouse_name'},
          { text: 'Status', value: 'status', sortable: false},
          { text: 'Actions', value: 'id', sortable: false }
        ],
        approvingItem: null,
        approveDialog: false,
        cancellingItem: null,
        cancelDialog: false,
        filter: {
          id: "",
          warehouse_id: "",
          status: ""
        },
        statuses: [
          {
            id: "",
            title: "All"
          }
        ],
        defaultWarehouses: [
          {
            id: "",
            title: "All"
          }
        ],
        warehouses: []
      }
    },
    created () {
      	let breadcrumbs = [
	      	{
	          text: 'Dashboard',
	          disabled: false,
	          href: '/dashboard'
	        },
	        {
	          text: 'Stock Dispatch',
	          disabled: true
	        },
	        {
	          text: 'List',
	          disabled: true
	        }
       ]

      this.$store.commit('setBreadcrumbs', breadcrumbs)
      this.$store.commit('setPageTitle', 'Manage Stock Dispatch')
    },
    methods: {

      loadPage () {

        let api_path = this.config.apis.getStockDispatches.replace(":page", this.currentPage).replace(":perPage", this.paginationOptions.rowsPerPage)
          
        let filterArray = []

        for (const [key, val] of Object.entries(this.filter)) {
          filterArray.push(`${key}=${val}`)
        }

        api_path += '?' + filterArray.join('&')
        
        this.processing = true
        this.axios.get(api_path)
          .then((response) => {
            this.processing = false
            if (this.isSuccessResponse(response)) {
            	this.items = response.data.data.items
              this.$store.commit('setItemsCount', response.data.data.total)
            }
            else{
            	this.items = []
              this.$store.commit('setItemsCount', 0)
            }
          })
          .catch((error) => {
            this.processing = false
          })
      },

      confirmApproveItem (item) {
        this.approvingItem = item
        this.approveDialog = true
      },

      confirmCancelItem (item) {
        this.cancellingItem = item
        this.cancelDialog = true
      },

      closeApproveDialog () {
        this.approvingItem = null
        this.approveDialog = false
      },

      closeCancelDialog () {
        this.cancellingItem = null
        this.cancelDialog = false
      },

      approveStockDispatch () {
        
        if (!this.approvingItem) return

        this.processing = true
        this.axios.put(this.config.apis.approveStockDispatch.replace(":id", this.approvingItem.id))
          .then((response) => {
            if (this.isSuccessResponse(response)) {

              this.approvingItem.status = this.config.dispatchStatus.approved

              this.notifySuccess('updateSuccess')
              this.closeApproveDialog()
            }
            else{
              this.notifyError('updateError')
            }
            this.processing = false
          })
          .catch((error) => {
            this.processing = false
            this.closeApproveDialog()
          })

      },

      cancelStockDispatch () {
        
        if (!this.cancellingItem) return

        this.processing = true
        this.axios.put(this.config.apis.cancelStockDispatch.replace(":id", this.cancellingItem.id))
          .then((response) => {
            if (this.isSuccessResponse(response)) {

              this.cancellingItem.status = this.config.dispatchStatus.cancelled

              this.notifySuccess('updateSuccess')
              this.closeCancelDialog()
            }
            else{
              this.notifyError('updateError')
            }
            this.processing = false
          })
          .catch((error) => {
            this.processing = false
            this.closeCancelDialog()
          })

      }

    },
    mounted () {

      for (const [key, val] of Object.entries(this.config.dispatchStatus)) {
          this.statuses.push({id: val, title: key})
      }

      this.getAllData('warehouse')
        .then((response) => {
            this.warehouses = [...this.defaultWarehouses, ...response]
        })

    },

    computed: {

    },

    watch: {

    },
    
    components: {
      'dispatch-list-item': StockDispatchListItem
    }

  }
</script>
